import { useState, useEffect } from "react";
import { axiosAuthFetch } from "../../helpers/axios";
import { fetchAllPages } from "../../helpers/pagination";
import { API_BASE_URL } from "../../constants";

const PAGE_SIZE = 100;

// Henter ALLE ingredienser, side for side. Strapi returnerer bare 25 uten
// paginering og kan kappe pageSize til sin egen maxLimit, så vi stoler på
// meta.pagination fra serveren i stedet for én stor side.
export async function GetAllIngredients() {
    return fetchAllPages(async (page) => {
        const response = await axiosAuthFetch(
            `${API_BASE_URL}/ingredients?populate=*&sort=id:asc&pagination[pageSize]=${PAGE_SIZE}&pagination[page]=${page}`
        );
        return { data: response?.data, pagination: response?.meta?.pagination };
    });
}

const listeners = new Set();

// Kalles etter at en ingrediens er opprettet/endret, slik at alle velgere som
// allerede er montert henter lista på nytt uten at siden må lastes inn igjen.
export function notifyIngredientsChanged() {
    listeners.forEach((listener) => listener());
}

// Felles kilde for alle ingrediens-velgere. Henter ved mount, når en ingrediens
// er opprettet (notifyIngredientsChanged) og når vinduet får fokus igjen
// (f.eks. hvis ingrediensen ble opprettet i en annen fane).
export function useAllIngredients() {
    const [ingredients, setIngredients] = useState([]);

    useEffect(() => {
        let isActive = true;
        let latestRequest = 0;

        async function load() {
            const request = ++latestRequest;
            try {
                const data = await GetAllIngredients();
                // Bare det nyeste kallet får sette lista, så et tregt eldre svar ikke overskriver
                if (isActive && request === latestRequest) setIngredients(data);
            } catch (error) {
                console.error('Error fetching ingredients:', error);
            }
        }

        function handleVisibility() {
            if (document.visibilityState === 'visible') load();
        }

        load();
        listeners.add(load);
        window.addEventListener('focus', load);
        document.addEventListener('visibilitychange', handleVisibility);

        return () => {
            isActive = false;
            listeners.delete(load);
            window.removeEventListener('focus', load);
            document.removeEventListener('visibilitychange', handleVisibility);
        };
    }, []);

    return ingredients;
}
